const scrollToTopWrp = document.querySelector('.scroll-to-top');
const scrollToTopBtn = scrollToTopWrp && scrollToTopWrp.querySelector('.scrollToTop');

if (scrollToTopWrp && scrollToTopBtn) {
  let ticking = false;

  function showScrollToTop() {
    ticking = false;
    scrollToTopWrp.classList.toggle('active', window.scrollY > window.innerHeight / 2);
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(showScrollToTop);
    }
  }, { passive: true });

  showScrollToTop();

  // Native smooth scroll: no stepping/crawl near the top, and the user can interrupt it
  scrollToTopBtn.addEventListener('click', () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
}
